module.exports = __webpack_public_path__ + "static/media/LogicLever3_1_3.9479ebb7.png";